// extracted by mini-css-extract-plugin
module.exports = {"section":"MerchantFilterModal_section__3fO0B","checkbox":"MerchantFilterModal_checkbox__1qzCb"};